import type { TFunction } from 'i18next';
import { RiskLevelEnum } from 'querys/regional-overview/regional-overview.query.models';

export const getRiskLabel = (riskLevel: RiskLevelEnum, t: TFunction): string => {
  switch (riskLevel) {
    case RiskLevelEnum.HIGH:
      return t('pages.regional_overview.regional_risk.level_risk.high_risk');
    case RiskLevelEnum.MEDIUM:
      return t('pages.regional_overview.regional_risk.level_risk.medium_risk');
    case RiskLevelEnum.LOW:
      return t('pages.regional_overview.regional_risk.level_risk.low_risk');
    case RiskLevelEnum.NO_RISK:
      return t('pages.regional_overview.field_details_card.no_risk');
    default:
      return t('pages.regional_overview.field_details_card.missing_data_tag');
  }
};
